import { useAuthStore } from '@/stores/auth'
import { useOutboxStore } from '@/stores/outbox.js'

const baseURL = import.meta.env.VITE_API_URL || 'http://localhost:8000'

async function request(endpoint, { method = 'GET', body, headers = {} } = {}) {
    const auth = useAuthStore()
    const outbox = useOutboxStore()

    const config = {
        method,
        headers: {
            'Content-Type': 'application/json',
            ...headers,
        },
    }

    // adaugă body dacă există
    if (body) {
        config.body = JSON.stringify(body)
    }

    // adaugă token dacă user-ul e logat
    if (auth?.token) {
        config.headers.Authorization = `Bearer ${auth.token}`
    }

    // salveaza local cererea...

    const url = `${baseURL}${endpoint}`

    if (!navigator.onLine) {
        console.log('Offline, saving request in outbox')
        await outbox.addRequest({
                url,
                method: config.method || 'GET',
                headers: config.headers || { 'Content-Type': 'application/json' },
                body: config.body ? JSON.parse(config.body) : null,
            })
    }


    try {
        const response = await fetch(url, config)

        if (!response.ok) {
            // dacă e 401 → token invalid/expirat
            if (response.status === 401) {
                auth.logout()
            }

            const errorText = await response.text()
            throw new Error(
                `API error ${response.status}: ${errorText || response.statusText}`
            )
        }

        // dacă nu e conținut (204 No Content)
        if (response.status === 204) {
            return null
        }

        return await response.json()
    } catch (error) {
        console.error('API request failed:', error)
        throw error
    }
}

export const apiClient = {
    get: (endpoint, options = {}) => request(endpoint, { ...options, method: 'GET' }),
    post: (endpoint, body, options = {}) =>
        request(endpoint, { ...options, method: 'POST', body }),
    put: (endpoint, body, options = {}) =>
        request(endpoint, { ...options, method: 'PUT', body }),
    del: (endpoint, body, options = {}) =>
        request(endpoint, { ...options, method: 'DELETE', body }),
}
